<div
  class="activity-details bo-label-text activity vo-body-regular-14 pb-5"
  *ngFor="let caseRequestStatusHistory of getCaseRequestStatusHistoryList()"
  [ngClass]="{
    'system-generated activity-system':
      caseRequestStatusHistory.DecisionTypeCode === referenceDataOptionLists.CaseActivityTypeSystemStatusChange,
    'human-generated activity-human':
      caseRequestStatusHistory.DecisionTypeCode === referenceDataOptionLists.CaseActivityTypeHumanStatusChange
  }"
>
  <span [innerHtml]="(referenceDataLabels.CaseSummaryStatusUpdate | localizeLabel) + ' '"></span>
  <span class="bo-info-text" [innerHtml]="caseRequestStatusHistory.CreatedDate | date : 'dd/MM/yyyy HH:mm:ss'"></span>
  <span class="bo-info-text" [innerHtml]="' ' + (referenceDataLabels.By | localizeLabel) + ' '"></span>
  <span class="bo-info-text">{{ caseRequestStatusHistory.UserFullName }} </span>
  <span class="bo-info-text" *ngIf="caseRequestStatusHistory.UserCompany"
    >({{
      caseRequestStatusHistory.UserCompany !== referenceDataLabels.InternalCompanyName
        ? caseRequestStatusHistory.UserCompany
        : (caseRequestStatusHistory.UserCompany | localizeLabel)
    }})
  </span>
  {{ pipeSymbol }}
  <span
    boiCategorizeCaseStatus
    [caseStatus]="caseRequestStatusHistory.StatusCode"
    [innerHtml]="caseRequestStatusHistory.StatusCode | localizeOption : referenceDataOptionLists.SwitchCaseStatus"
  ></span>
</div>
